import { z } from 'zod';
const Access = z.object({
    allow_anonymous: z.boolean(),
});
const Attended = z.object({
    require_host_approval: z.boolean(),
    approval_timeout_sec: z.number().int().positive(),
});
const Unattended = z
    .object({
    enabled: z.boolean(),
    access_code_hash: z.string().nullable(),
    lockout_after_failures: z.number().int().positive(),
    lockout_duration_min: z.number().int().positive(),
})
    .refine((u) => !u.enabled || (typeof u.access_code_hash === 'string' && u.access_code_hash.length > 0), {
    message: 'unattended.access_code_hash is required when unattended.enabled is true',
    path: ['access_code_hash'],
});
const TrustedDevice = z.object({
    session_timeout_min: z.number().int().positive(),
    idle_timeout_min: z.number().int().positive(),
});
const Network = z.object({
    ip_allowlist: z.array(z.string()),
});
const Reattach = z.object({
    grace_window_sec: z.number().int().nonnegative(),
});
export const HostPolicy = z.object({
    access: Access,
    attended: Attended,
    unattended: Unattended,
    trusted_device: TrustedDevice,
    network: Network,
    reattach: Reattach,
});
//# sourceMappingURL=schema.js.map